/**
 * GlobalHeader functionality.
 * @author Dayne Coulson-Hoffacker
 */

export default class GlobalHeader {
	/**
	 * Constructs a new GlobalHeader instance.
	 * @param {Object} options - Options.
	 * @param {HTMLElement} options.element - Container.
	 */

	constructor(options) {
		this.element = options.element
		this.navToggle = this.element.querySelector('[data-component="nav-toggle"]')
		this.mainNav = this.element.querySelector('[data-component="main-nav"]')
		this.nav = this.mainNav.querySelector('nav')

		this.mainNav.addEventListener('click', () => {
			if (document.body.classList.contains('nav-open')) {
				document.body.classList.remove('nav-open')
			} else {
				document.body.classList.add('nav-open')
			}
		})

		this.navToggle.addEventListener('click', (event) => {
			event.stopPropagation()
			document.body.classList.toggle('nav-open')
		})

		// this.nav.addEventListener('click', (event) => {
		//   event.stopPropagation()
		// })
	}
}
